import { useEffect, useState } from 'react'
import { showToast } from '../components/toast/PlaygroundToast'
import type { ConnectionMode } from './useConnection'

interface UseAutoConnectOptions {
  shouldConnect: boolean
  connect: (mode: ConnectionMode) => Promise<void>
}

export function useAutoConnect({
  shouldConnect,
  connect,
}: UseAutoConnectOptions) {
  const [hasAutoConnected, setHasAutoConnected] = useState(false)

  useEffect(() => {
    const autoConnect = async () => {
      try {
        await connect('env')
        setHasAutoConnected(true)
      } catch (error) {
        console.error('[Playground] Failed to auto-connect:', error)
        showToast.error('Failed to connect to LiveKit')
      }
    }

    if (!shouldConnect && !hasAutoConnected) {
      autoConnect()
    }
  }, [connect, shouldConnect, hasAutoConnected])

  return hasAutoConnected
}
